@if (showHits()) {
  @for (hit of hits(); track hit.objectID; let i = $index) {
    <div class="hit" [tabIndex]="0" (keyup.enter)="selectCustomer(hit, true)">
      <div class="flex-grow" (click)="selectCustomer(hit, true)">
        <p class="small-text">
          #<span [innerHTML]="hit._highlightResult.vismaCustomerId.value"></span>
          <span class="px-1">•</span>
          @if (hit.accountType.toString() === '1') {
            Privat
          } @else if (hit.accountType.toString() === '2') {
            Erhverv
          } @else {
            Ukendt
          }
        </p>
        <h2 [innerHTML]="hit._highlightResult.name.value"></h2>
        <p>E: <span [innerHTML]="hit._highlightResult.email.value"></span> <span class="px-1">•</span> T: {{hit.phoneNumberCountryCode && ('+' + hit.phoneNumberCountryCode)}} <span [innerHTML]="hit._highlightResult.phoneNumber.value"></span></p>
      </div>
      <div class="hit-buttons">
        <button mat-flat-button color="primary" (click)="selectCustomer(hit, true)" tabindex="-1">Tilføj til bon</button>
        <a (click)="selectCustomer(hit)">Se kunde</a>
      </div>
    </div>
  }
}
